import { getApiBaseUrl } from "config";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";

export const baseQuery = (args, api, extraOptions) =>
  fetchBaseQuery({
    baseUrl: getApiBaseUrl(),
    mode: "cors",
    // The session cookie is the credential; there is no bearer token to set
    // an Authorization header from (mvp-next ADR 0004).
    credentials: "include",
  })(args, api, extraOptions);
